import data from "./marques_modeles.json";

export const MARQUES = Object.keys(data).sort((a, b) => a.localeCompare(b, "fr"));

/**
 * Returns the list of models for a given marque (case-insensitive match).
 * If the marque is unknown, returns an empty array (user can type freely).
 */
export function getModelesForMarque(marque) {
  if (!marque) return [];
  const m = marque.trim().toLowerCase();
  const key = Object.keys(data).find((k) => k.toLowerCase() === m);
  return key ? data[key] : [];
}
